module.exports = __webpack_public_path__ + "img/VP-ProfiNew-Repairing.763cc895.jpg";